(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[675],{

/***/ 7012:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retrospective-reviews",
      function () {
        return __webpack_require__(3834);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var ButtonLink = function(param) {
    var children = param.children, uri = param.uri;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: uri,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "px-4 py-2 mt-8 bg-white-lighter text-lg text-blue border-2 border-blue hover:bg-blue hover:text-white-light inline-block font-[sans-serif]",
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonLink);


/***/ }),

/***/ 3976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./lib/seo-config.js
var SITE_CONFIG = {
    name: "Evry Health",
    url: "https://www.evryhealth.com",
    defaultOgImage: "https://www.evryhealth.com/og-image.png",
    twitterCard: "summary_large_image"
};
var PAGE_SEO = {
    "": {
        title: "Evry Health | Modern Health Insurance for Texas Employers & Members",
        description: "Evry Health offers transparent, member-first health insurance for Texas employers (51+ employees) and their members — with $0 telehealth, no copays, no deductibles, and a personalized care team.",
        ogDescription: "Transparent, member-first health insurance for Texas employers and members. No copays. No deductibles. $0 telehealth.",
        twitterTitle: "Evry Health",
        twitterDescription: "Modern health insurance for Texas employers and members."
    },
    "admission-notification": {
        title: "Inpatient Admission Notification | Evry Health",
        description: "How to submit inpatient admission notifications to Evry Health to ensure timely, accurate claims processing.",
        ogDescription: "How to submit inpatient admission notifications to Evry Health.",
        twitterTitle: "Admission Notification | Evry Health",
        twitterDescription: "Submit inpatient admission notifications to Evry Health."
    },
    careers: {
        title: "Careers at Evry Health | Join Our Team",
        description: "We're making health insurance work again. Explore open roles at Evry Health in Dallas, Texas.",
        twitterTitle: "Careers at Evry Health",
        twitterDescription: "Explore open roles at Evry Health in Dallas, Texas."
    },
    "community-resources": {
        title: "Texas Community Resources for Members | Evry Health",
        description: "A curated list of local community, health, food, and legal resources across Texas for Evry Health members.",
        twitterTitle: "Texas Community Resources | Evry Health",
        twitterDescription: "Community, health, food, and legal resources for Evry Health members in Texas."
    },
    "contact-us": {
        title: "Contact Evry Health | Get a Quote",
        description: "Get in touch with Evry Health for plan quotes, member support, or general questions. Call 1-855-579-3879.",
        ogDescription: "Get in touch with Evry Health for plan quotes, member support, or general questions.",
        twitterTitle: "Contact Evry Health",
        twitterDescription: "Get a quote or ask us anything. Call 1-855-579-3879."
    },
    faqs: {
        title: "Frequently Asked Questions | Evry Health",
        description: "Answers to common questions about Evry Health plans, coverage, virtual care, and member benefits.",
        twitterDescription: "Answers to common questions about Evry Health plans and coverage."
    },
    forms: {
        title: "Forms & Notices | Evry Health",
        description: "Download member and provider forms, notices, and resources from Evry Health.",
        twitterDescription: "Download forms and notices from Evry Health."
    },
    fwa: {
        title: "Report Fraud, Waste & Abuse | Evry Health",
        description: "How Evry Health members and providers can report suspected fraud, waste, or abuse.",
        twitterDescription: "Report suspected fraud, waste, or abuse to Evry Health."
    },
    "how-we-compare": {
        title: "How Evry Health Compares | Plan Comparison",
        description: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care, and transparent premiums.",
        ogDescription: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care.",
        twitterTitle: "How Evry Health Compares",
        twitterDescription: "Compare Evry Health plans against traditional carriers."
    },
    "how-we-do-it": {
        title: "How Evry Health Works | Built for Modern Workforces",
        description: "Evry Health is built for the modern business and the mobile workforce. See how our health insurance plans work.",
        twitterTitle: "How Evry Health Works",
        twitterDescription: "Built for the modern business and the mobile workforce."
    },
    "join-the-evry-network": {
        title: "Join the Evry Health Provider Network",
        description: "Apply to join the Evry Health provider network. Faster payments. Transparent terms.",
        twitterTitle: "Join the Evry Health Network",
        twitterDescription: "Apply to join the Evry Health provider network."
    },
    login: {
        title: "Sign In | Evry Health",
        description: "Sign in to the Evry Health member portal.",
        noindex: true
    },
    "meet-your-new-team": {
        title: "Meet Your Evry Health Care Team",
        description: "Every Evry Health member gets a dedicated team of nurses, nutritionists, and doctors — included at no extra cost.",
        ogDescription: "Every member gets a dedicated team of nurses, nutritionists, and doctors — at no extra cost.",
        twitterDescription: "A dedicated team of nurses, nutritionists, and doctors — included at no extra cost."
    },
    members: {
        title: "Member Registration | Evry Health",
        description: "Register for your Evry Health member portal account.",
        noindex: true
    },
    mobileapp: {
        title: "Evry Health Mobile App | Manage Your Plan On the Go",
        description: "Download the Evry Health mobile app to view your ID card, find providers, message your care team, and more.",
        ogDescription: "Download the Evry Health mobile app to view your ID card, find providers, and message your care team.",
        twitterTitle: "Evry Health Mobile App",
        twitterDescription: "Manage your health plan on the go with the Evry Health app."
    },
    news: {
        title: "News & Press | Evry Health",
        description: "The latest news, press releases, and announcements from Evry Health.",
        twitterDescription: "The latest news and announcements from Evry Health."
    },
    "non-discrimination-policy": {
        title: "Non-Discrimination Policy | Evry Health",
        description: "Evry Health's commitment to non-discrimination and language assistance for members.",
        twitterDescription: "Non-discrimination and language assistance for all members."
    },
    "our-story": {
        title: "Our Story | Evry Health",
        description: "Evry Health is on a mission to build the health insurance company we've always wanted for ourselves.",
        ogDescription: "We're on a mission to build the health insurance company we've always wanted for ourselves.",
        twitterDescription: "Building the health insurance company we've always wanted."
    },
    partners: {
        title: "Partners | Evry Health",
        description: "The partners and providers Evry Health works with to deliver modern health insurance.",
        twitterDescription: "Partners and providers delivering modern health insurance."
    },
    "prior-auth-list-updates": {
        title: "Prior Authorization List Updates | Evry Health",
        description: "Recent updates to the Evry Health prior authorization list for providers.",
        twitterDescription: "Recent updates to the prior authorization list for providers."
    },
    "prior-auth-tool": {
        title: "Prior Authorization Tool | Evry Health for Providers",
        description: "Look up whether a procedure requires prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization Tool | Evry Health",
        twitterDescription: "Check if prior authorization is required for a procedure."
    },
    "prior-authorization": {
        title: "Prior Authorization | Evry Health for Providers",
        description: "Information for providers on which procedures require prior authorization with Evry Health.",
        ogDescription: "Provider resources for prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization | Evry Health",
        twitterDescription: "Provider resources for prior authorization with Evry Health."
    },
    "privacy-policy": {
        title: "Privacy Policy | Evry Health",
        description: "How Evry Health collects, uses, and protects your personal and health information.",
        twitterDescription: "How Evry Health protects your personal and health information."
    },
    providerdirectory: {
        title: "Provider Directory | Evry Health",
        description: "Find in-network providers with the Evry Health provider directory.",
        noindex: true
    },
    "request-to-join": {
        title: "Request to Join | Evry Health Network",
        description: "Submit a request to join the Evry Health provider network. Simple application process.",
        ogDescription: "Submit a request to join the Evry Health provider network.",
        twitterTitle: "Request to Join | Evry Health",
        twitterDescription: "Join the Evry Health provider network."
    },
    "retrospective-reviews": {
        title: "Retrospective Reviews | Evry Health for Providers",
        description: "Learn how Evry Health determines coverage after treatment has been provided.",
        twitterTitle: "Retrospective Reviews | Evry Health",
        twitterDescription: "How Evry Health determines coverage after treatment."
    },
    rewards: {
        title: "Member Rewards | Evry Health",
        description: "Earn rewards for staying healthy as an Evry Health member.",
        twitterDescription: "Earn rewards for staying healthy with Evry Health."
    },
    terms: {
        title: "Terms of Use | Evry Health",
        description: "Terms of use for the Evry Health website and digital services.",
        twitterDescription: "Terms of use for Evry Health website and services."
    },
    "virtual-care": {
        title: "$0 Virtual Care & Telehealth | Evry Health",
        description: "Talk to a board-certified physician 24/7 for $0. On-demand virtual care included with every Evry Health plan.",
        twitterDescription: "Talk to a board-certified physician 24/7 for $0."
    },
    "why-choose-evry": {
        title: "Why Choose Evry Health | Texas Health Insurance",
        description: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth, and a personalized member care team.",
        twitterTitle: "Why Choose Evry Health",
        twitterDescription: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth."
    }
};
function getPageSeo(slug) {
    var page = PAGE_SEO[slug] || {};
    var title = page.title || SITE_CONFIG.name;
    var description = page.description || "";
    var ogTitle = page.ogTitle || title;
    var ogDescription = page.ogDescription || description;
    var ogImage = page.ogImage || SITE_CONFIG.defaultOgImage;
    var twitterTitle = page.twitterTitle || ogTitle;
    var twitterDescription = page.twitterDescription || ogDescription;
    var twitterImage = page.twitterImage || ogImage;
    var noindex = page.noindex || false;
    var url = slug === "" ? "".concat(SITE_CONFIG.url, "/") : "".concat(SITE_CONFIG.url, "/").concat(slug);
    return {
        title: title,
        description: description,
        url: url,
        ogTitle: ogTitle,
        ogDescription: ogDescription,
        ogImage: ogImage,
        twitterTitle: twitterTitle,
        twitterDescription: twitterDescription,
        twitterImage: twitterImage,
        noindex: noindex
    };
}

;// CONCATENATED MODULE: ./components/SEO/SEO.js





var SEO = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slug = ref.slug, overrides = ref.overrides;
    var router = (0,next_router.useRouter)();
    var resolvedSlug = slug !== undefined ? slug : router.pathname.replace(/^\//, "");
    var resolved = getPageSeo(resolvedSlug);
    var seo = overrides ? (0,_object_spread/* default */.Z)({}, resolved, overrides) : resolved;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: seo.ogTitle
            }, "title"),
            seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex,follow"
            }),
            !seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: SITE_CONFIG.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: seo.ogDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: seo.ogImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: SITE_CONFIG.twitterCard
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: seo.twitterTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: seo.twitterDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: seo.twitterImage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);


/***/ }),

/***/ 3834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_SEO_SEO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3976);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9875);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8368);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1782);
/* harmony import */ var _components_ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7432);
/* harmony import */ var _components_ButtonLink_ButtonLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3208);








var AdmissionNotification = function() {
    var classNames = function classNames() {
        for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
            classes[_key] = arguments[_key];
        }
        return classes.filter(Boolean).join(" ");
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), formList = ref[0], SetFormList = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], SetLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref2[0], SetError = ref2[1];
    var faqs = [
        {
            question: "What's the best thing about Switzerland?",
            answer: "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. <br /> Quas cupiditate laboriosam fugiat."
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO_SEO__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-100 h-1/2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute inset-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "object-cover w-full h-full",
                                                src: "videocallAtDesk.png",
                                                alt: "Healthcare provider on a video call"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    className: "text-3xl tracking-tight md:text-5xl text-darkBlue",
                                                    children: "Retrospective Reviews"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "max-w-lg mt-6 text-xl text-grey sm:max-w-3xl",
                                                    children: "Process of determining coverage after treatment has been given."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8 text-grey",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure */ .p, {
                                    as: "div",
                                    defaultOpen: true,
                                    children: function(param) {
                                        var open = param.open;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                                    className: "text-lg",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure.Button */ .p.Button, {
                                                        className: "flex items-start justify-between w-full text-left",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-xl text-blue",
                                                                children: "What is a retrospective review?"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "flex items-center ml-6 h-7",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                    className: classNames(open ? "-rotate-180" : "rotate-0", "h-6 w-6 transform"),
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure.Panel */ .p.Panel, {
                                                    as: "dd",
                                                    className: "pr-12 mt-2 text-base",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "A retrospective review is the process of determining coverage after treatment has been given."
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure */ .p, {
                                    as: "div",
                                    className: "pt-6",
                                    defaultOpen: true,
                                    children: function(param) {
                                        var open = param.open;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                                    className: "text-lg",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure.Button */ .p.Button, {
                                                        className: "flex items-start justify-between w-full text-left",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-xl text-blue",
                                                                children: "When is retrospective review available?"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "flex items-center ml-6 h-7",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                    className: classNames(open ? "-rotate-180" : "rotate-0", "h-6 w-6 transform"),
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure.Panel */ .p.Panel, {
                                                    as: "dd",
                                                    className: "pr-12 mt-2 text-base",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            children: "Retrospective review is available to a provider when all of the following criteria is met:"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            className: "ml-8 list-disc",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: "Confirming member eligibility and the availability of benefits."
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: "The service has not been submitted for payment or processing."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        "AND one of the following:",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            className: "ml-8 list-disc",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: "If the health plan authorized an initial inpatient request, a subsequent request will be accepted for review within 3 business days of the last approved day."
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: "An additional service was identified as necessary when the original authorized service was performed. Requests for this additional service will be accepted within 5 business days of the performed service."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure */ .p, {
                                    as: "div",
                                    className: "pt-6",
                                    defaultOpen: true,
                                    children: function(param) {
                                        var open = param.open;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                                    className: "text-lg",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure.Button */ .p.Button, {
                                                        className: "flex items-start justify-between w-full text-left",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-xl text-blue",
                                                                children: "Retrospective review is not available for"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "flex items-center ml-6 h-7",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                    className: classNames(open ? "-rotate-180" : "rotate-0", "h-6 w-6 transform"),
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Disclosure.Panel */ .p.Panel, {
                                                    as: "dd",
                                                    className: "pr-12 mt-2 text-base",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                        className: "ml-8 list-disc",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: "Elective ambulatory or inpatient services on the prior authorization list for which prior authorization did not occur before providing the service."
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: "Services requiring notification within 3 business days that did not meet notification requirements (notification of inpatient admissions is required within 3 business days of admission date)."
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                children: [
                                                                    " ",
                                                                    "Services not included on the prior authorization list.",
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: "Services that do not require prior authorization under the terms of a member’s plan."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AdmissionNotification);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 1782:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function ChevronDownIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 9l-7 7-7-7"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronDownIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,875,991,841,774,888,179], function() { return __webpack_exec__(7012); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);